<template>
  <div>
    <div
      v-if="isLoading"
      class="loader"
    >
      <b-spinner
        variant="success"
        style="width: 6rem; height: 6rem;"
        label="Large Spinner Text Centered"
      />
    </div>
    <div
      v-if="actionType === 'resetPassword'"
      :class="{ active: isLoading }"
    >
      <img
        class="djuliLogo"
        alt="djuliLogo"
        src="../assets/MainMenu/djuliImage.png"
      >
      <b-container class="form-container">
        <b-row class="pt-4">
          <h3 class="mb-4 text-xl md:text-2xl text-green-700 font-bold">
            Reset Password
          </h3>
        </b-row>
        <b-row v-if="validCode">
          <b-form
            class="w-100"
            @submit.prevent="resetPassword"
          >
            <b-form-group
              label="Password:"
              label-for="password-text"
            >
              <b-form-input
                id="password-text"
                v-model.trim="password"
                type="password"
                :state="password === '' || (passwordValiation(password))"
                required
                placeholder="Choose your password"
              />
              <b-form-invalid-feedback class="input-live-feedback">
                The password must contain at least 8 characters, capital and lower case, and a special character
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
              label="Password Confirm:"
              label-for="password-text-confirm"
              class="pb-4"
            >
              <b-form-input
                id="password-text-confirm"
                v-model.trim="passwordConfirm"
                type="password"
                :state="password === '' || passwordConfirm === password"
                required
                placeholder="Repeat your password"
              />
              <b-form-invalid-feedback class="input-live-feedback">
                The password must match
              </b-form-invalid-feedback>
            </b-form-group>
            <b-button
              type="submit"
              class="login-btn"
              mode="flat"
              variant="primary"
            >
              Reset Password
            </b-button>
          </b-form>
        </b-row>
        <b-row
          v-else
          class="expired-div"
        >
          <h5>Sorry, your password reset link has expired.</h5>
        </b-row>
      </b-container>
    </div>
    <b-container v-else-if="actionType === 'verifyEmail'">
      <b-row class="py-4">
        <b-button
          class="verify-btn mx-auto"
          mode="flat"
          variant="primary"
          @click="activateAccount"
        >
          Verify Account
        </b-button>
      </b-row>
      <b-row>
        <img
          class="djuliLogo-shown mx-auto"
          alt="djuliLogo"
          src="../assets/MainMenu/djuliImage.png"
        >
      </b-row>
    </b-container>
    <b-container
      v-else
      class="m-3"
    >
      <b-row>
        <b-col>
          <h3>Sorry, no results were found for your request.</h3>
          <p>We couldn't execute your action</p>
        </b-col>
        <b-col>
          <img
            id="elemNotFoundImg"
            src="@/assets/configurationWindow/Error.png"
            alt="Element not found"
          >
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { getAuth, verifyPasswordResetCode, confirmPasswordReset, applyActionCode } from 'firebase/auth';

export default {
  name: 'LinkAction',
  data() {
    return {
      password: '',
      passwordConfirm: '',
      isLoading: false,
      validCode: false,
      code: '',
      actionType: '',
      showDjuliIcon: true
    };
  },
  async mounted() {
    this.code = this.$route.query.oobCode
    this.validCode = true
    this.actionType = this.$route.query.mode
    if (this.actionType === 'resetPassword') {
      if (typeof (this.code) !== 'undefined') {
        try {
          await verifyPasswordResetCode(getAuth(), this.code)
          this.validCode = true
        } catch {
          this.validCode = false
        }
      }
    }
  },
  methods: {
    async resetPassword() {
      if (!this.passwordValiation(this.password) || this.password !== this.passwordConfirm) {
        const errTitle = 'Invalid input'
        const errText = 'Please validate the inputs and try again'
        const errZone = 'Link Action'
        this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, errZone)
        return
      }
      this.isLoading = true;
      try {
        await confirmPasswordReset(getAuth(), this.code, this.password)
        await this.$alert(
          'Password updated',
          'Success',
          'success',
          {
            confirmButtonText: 'Ok'
          }
        );
        this.$router.replace('/login');
      } catch (error) {
        await this.$alert('Something went wrong, Please try again in a few minutes', 'Error', 'error');
      } finally {
        this.isLoading = false;
      }
    },
    passwordValiation(value) {
      return value.length >= 8 && /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.* )(?=.*[^a-zA-Z0-9]).{8,}$/.test(value)
    },
    async activateAccount() {
      try {
        await applyActionCode(getAuth(), this.code)
        await this.$alert(
          'Account verified',
          'Success',
          'success',
          {
            confirmButtonText: 'Ok'
          }
        );
        this.$router.replace('/login');
      } catch (error) {

        await this.$alert(
          'The link has expired. Please request a new one from the home page.',
          'Link expired',
          'error',
          {
            confirmButtonText: 'Ok'
          }
        );
        this.$router.replace('/login');
      }
    }
  },

};
</script>
<style lang="scss" scoped>
.djuliLogo {
  width: 30vw;
  position: fixed;
  left: 35vw;
  margin: auto;
  opacity: 0.5;
  z-index: -100;
}

.djuliLogo-shown {
  width: 25vw;
  margin: auto;
  opacity: 1;
  z-index: -100;
}

.form-group {
  margin-top: 1rem !important;
}

h3 {
  margin-top: 1rem !important;
}

.form-container {
  width: 18vw;
}

.active {
  opacity: 0.3
}

.loader {
  position: absolute;
  left: 46%;
  top: 35%;
}

.sign-btn {
  display: inline-flex;
  position: relative;
}

.btn-margin {
  margin-left: 0.2rem;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
}

.expired-div {
  color: red;
  align-items: center;
  text-align: center;
}

.verify-btn {
  height: 4rem;
  width: 20rem;
  font-size: 1.75rem;
}

#elemNotFoundImg {
  border-radius: 20px;
  margin: 2rem;
}
</style>
